import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const essentailDocsApi = createApi({
  baseQuery,
  reducerPath: 'essentailDocsApi',
  endpoints: builder => ({
    getEssentailData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.EssentialDocuments.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    updateEssentailDocs: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.EssentialDocuments.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useGetEssentailDataQuery, useUpdateEssentailDocsMutation } = essentailDocsApi;
